import React, { useEffect } from "react"
import { BrowserRouter, Switch, Route } from "react-router-dom"
import { AnimatePresence } from "framer-motion"
import { useAuth } from "./firebase/useAuth"
import { useStore } from "./context/context"

import Login from "./components/Login"
import Header from "./components/Header"
import Grid from "./components/Grid"
import Settings from "./components/Settings"
import GoPremiumForm from "./components/GoPremiumForm"
import { GoFreeComfirmation } from "./components/GoFree"

import moment from "moment"
import "moment/locale/fr"
import { Loading } from "./helpers/components"
import Notification from "./components/Notification"

moment.locale("fr")

export default function App() {
  const [currentUser, profileIsLoading] = useAuth()
  const { notificationTitle, notificationType, dispatch } = useStore()

  useEffect(() => {
    const timeout = setTimeout(() => dispatch({ type: "SET_NOTIFICATION", payload: {
      text: "", type: "success"
    }}), 3000)
    return () => clearTimeout(timeout)
  }, [notificationTitle, notificationType])

  if(profileIsLoading) return <Loading title="Chargement..." />
  if(!currentUser) {
    return (
      <>
        <Login />
        <Notification title={notificationTitle} type={notificationType} />
      </>
    )
  } else {
    return (
      <BrowserRouter>
        <Header />
          <AnimatePresence>
            <Switch>
              <Route exact path="/" component={Grid} />
              <Route exact path="/settings" component={Settings} />
              <Route exact path="/premiumform" component={GoPremiumForm} />
              <Route exact path="/freecomfirmation" component={GoFreeComfirmation} />
            </Switch>
          </AnimatePresence>
        <Notification title={notificationTitle} type={notificationType} />
      </BrowserRouter>
    )
  }
}
